<template>
  <v-app>
    <v-main class="ma-3">
      <Header/>
      <router-view/>
      <Footer/>
    </v-main>
  </v-app>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'App',

  components: {
    Header,
    Footer
  },

  data: () => ({
    //
  }),
};
</script>
